// ฟอนต์ไทย Sarabun (OFL) อยู่ใน public/fonts — ใช้ทั้งแสดงบนจอและฝังลง PDF ตอนบันทึก
export const UI_FONT_FAMILY = "PdfEditorSarabun";

let fontsPromise = null;

export function loadEditorFonts() {
  if (!fontsPromise) {
    const base = `${process.env.PUBLIC_URL || ""}/fonts`;
    const get = async (name) => {
      const res = await fetch(`${base}/${name}`);
      if (!res.ok) throw new Error(`โหลดฟอนต์ ${name} ไม่สำเร็จ`);
      return new Uint8Array(await res.arrayBuffer());
    };

    fontsPromise = Promise.all([get("Sarabun-Regular.ttf"), get("Sarabun-Bold.ttf")])
      .then(async ([regular, bold]) => {
        try {
          const faces = [
            new FontFace(UI_FONT_FAMILY, regular.slice().buffer, { weight: "400" }),
            new FontFace(UI_FONT_FAMILY, bold.slice().buffer, { weight: "700" }),
          ];
          await Promise.all(faces.map((face) => face.load()));
          faces.forEach((face) => document.fonts.add(face));
        } catch (error) {
          // แสดงบนจอใช้ฟอนต์สำรอง ไม่กระทบไฟล์ที่บันทึก
        }
        return { regular, bold };
      })
      .catch((error) => {
        fontsPromise = null;
        throw error;
      });
  }
  return fontsPromise;
}
